<template>
    <div class="container sticky-top-cust mt-2">
        <div class="card">
            <div class="card-body p-2">
                <div class="row">
                    <div class="col-sm-6 mb-1">
                        <input v-model.trim="keyword"  type="search" class="form-control" maxlength="100" spellcheck=false placeholder="会社名・会社Group・案件ID・案件名"></input>
                    </div>
                    <div class="col-sm-6 d-flex mb-1">
                        <div class="mr-1 flex-fill">
                            <input v-model.trim="freeword"  type="search" class="form-control" maxlength="100" spellcheck=false placeholder="メール本文('@'でand検索可)"></input>
                        </div>
                        <!-- 検索ボタン -->
                        <div class="px-1">
                            <button type="button" class="btn btn-primary" @click="searchProj">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                        <div v-show="showMailInfo" class="px-1">
                            <button type="button" class="btn btn-primary" @click="toggleMailGroup">
                                <i class="fas fa-filter"></i>
                            </button>
                        </div>
                        <div v-show="showOptAllMenu" class="px-1">
                            <button type="button" class="btn btn-primary" @click="toggleOptAllMenu">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card card-body p-1 mb-1">
                    <div class="d-flex">
                        <div class="form-group form-check mb-0 mr-3">
                            <input type="checkbox" v-model="foreigner" class="form-check-input">
                            <small>外国籍OK</small>
                        </div>
                        <div class="form-group form-check mb-0 mr-3">
                            <input type="checkbox" v-model="remote" class="form-check-input">
                            <small>リモートOK</small>
                        </div>
                        <div class="form-group form-check mb-0 ml-auto">
                            <input type="checkbox" v-model="allsearch" class="form-check-input">
                            <small>All検索</small>
                        </div>
                    </div>
                </div>

                <!-- 一括操作メニュー -->
                <div v-show="showOptAllMenu" class="collapse" id="opt-all">
                    <div class="card card-body p-1">
                        <div>
                            <button class="btn btn-link" @click="optConfirm('allRecentDay')" :disabled="allsearch">一括受信日更新</button>
                            <button class="btn btn-link" @click="optConfirm('allProjOff')" :disabled="allsearch">一括終了にする</button>
                        </div>
                    </div>
                </div>

                <!-- メールグループ -->
                <div v-show="showMailInfo" class="collapse" id="mail-group">
                    <mail-group class="mt-1" :list="mailGroupList" type="4" :opt="mailOpt"></mail-group>
                    <div class="mt-2">
                        <small class="text-muted">※本日、既に個別送信済みの案件は一括送信対象外になる</small>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import MailGroup from 'pages/commons/modal/selectMailGroup/SelectMailGroup'

    export default {
        components: {
            MailGroup,
        },
        data () {
            return {
                keyword: '',
                freeword: '',
                foreigner: false,
                remote: false,
                allsearch : false,
                // 更新用
                keyword_bk: '',
                freeword_bk: '',
                foreigner_bk: false,
                remote_bk: false,
                allsearch_bk: false
            }
        },
        computed: {
            showMailInfo () {
                let doStr = this.$route.params.do
                return doStr == 'opening' || doStr == 'private' ? true : false 
            },
            showOptAllMenu () {
                let doStr = this.$route.params.do
                return doStr == 'timeout' ? true : false 
            },
            mailGroupList () {
                return this.getListObj ? this.getListObj.mail_group : []
            },
            mailOpt () {
                return {do: this.$route.params.do}
            },
            ...mapGetters(['getListObj'])
        },
        methods: {
            getSearchItems (type='new') {
                return {
                    key: JSON.stringify(type == 'new' ? this.keyword : this.keyword_bk),
                    free: JSON.stringify(type == 'new' ? this.freeword : this.freeword_bk),
                    foreigner: JSON.stringify(type == 'new' ? this.foreigner : this.foreigner_bk),
                    remote: JSON.stringify(type == 'new' ? this.remote : this.remote_bk),
                    allsearch: JSON.stringify(type == 'new' ? this.allsearch : this.allsearch_bk),
                    skip: '0',
                    status: this.$route.params.do
                }
            },
            getSearchItemsBk () {
                return {
                    keyword: this.keyword_bk,
                    freeword: this.freeword_bk,
                    foreigner: this.foreigner_bk,
                    remote: this.remote_bk,
                    allsearch: this.allsearch_bk
                }
            },
            optConfirm (opt) {
                let lev = 2
                let msg = ''
                if (opt == 'allRecentDay') {
                    msg = '一括受信日更新を行いますか？'
                }
                if (opt == 'allProjOff') {
                    msg = '一括終了を行いますか？'
                }
                this.$parent.openMsg(lev, msg, opt)
            },
            updateAllRecentInDay () {
                let data = this.getSearchItemsBk()
                this.$store.dispatch('changeCmpProjInfoCommon', {
                    processId: 'updateAllRecentInDay',
                    data: JSON.stringify(data)
                })
            },
            allProjOff () {
                let data = this.getSearchItemsBk()
                this.$store.dispatch('changeCmpProjInfoCommon', {
                    processId: 'allProjOff',
                    data: JSON.stringify(data)
                })
            },
            toggleOptAllMenu () {
                if ($('#opt-all').hasClass('show')) {
                    $('#opt-all').collapse('hide')
                } else {
                    $('#opt-all').collapse('show')
                }
            },
            toggleMailGroup () {
                if ($('#mail-group').hasClass('show')) {
                    $('#mail-group').collapse('hide')
                } else {
                    $('#mail-group').collapse('show')
                }
            },
            searchProj () {
                this.keyword_bk = this.keyword
                this.freeword_bk = this.freeword
                this.foreigner_bk = this.foreigner
                this.remote_bk = this.remote
                this.allsearch_bk = this.allsearch

                this.$parent.searchProj()
            },
            resetThis () {
                this.keyword = ''
                this.freeword = ''
                this.foreigner = false
                this.remote = false
                this.allsearch = false
                this.keyword_bk = ''
                this.freeword_bk = ''
                this.foreigner_bk = false
                this.remote_bk = false
                this.allsearch_bk = false
            }
        }
    }
</script>

<style lang="stylus" scoped>
.sticky-top-cust 
    position: sticky;
    top: 120px!important;
    z-index: 98;
</style>
